import { SlideChangeSources } from './CarouselInterfaces';

export interface CarouselReducerState {
  currentSlideIndex: number;
  maxIndex: number;
  latestSource: SlideChangeSources;
  direction: string | null;
}

export interface CarouselReducerAction {
  type: string;
  payload?: any;
}

export function getReducerInitState(
  initialSlideIndex: number,
  maxSlideIndex: number,
  latestSource: SlideChangeSources = null,
): CarouselReducerState {
  return {
    currentSlideIndex: initialSlideIndex,
    maxIndex: maxSlideIndex,
    latestSource: latestSource,
    direction: null,
  };
}

export function reducer(
  state: CarouselReducerState,
  action: CarouselReducerAction,
): CarouselReducerState {
  switch (action.type) {
    case 'next':
      return {
        currentSlideIndex:
          state.currentSlideIndex < state.maxIndex
            ? state.currentSlideIndex + 1
            : 0,
        maxIndex: state.maxIndex,
        latestSource: action.payload.source ?? null,
        direction: action.type,
      };
    case 'prev':
      return {
        currentSlideIndex:
          state.currentSlideIndex > 0
            ? state.currentSlideIndex - 1
            : state.maxIndex,
        maxIndex: state.maxIndex,
        latestSource: action.payload.source ?? null,
        direction: action.type,
      };
    case 'goto':
      if (state.currentSlideIndex === action.payload.newSlideIndex) {
        return state;
      }
      return {
        currentSlideIndex: action.payload.newSlideIndex ?? null,
        maxIndex: state.maxIndex,
        latestSource: action.payload.source ?? null,
        direction: action.type,
      };
    case 'reset':
      return getReducerInitState(
        action.payload.slideIndex,
        action.payload.maxIndex,
      );
    default:
      throw new Error();
  }
}
